module.exports = __webpack_public_path__ + "static/media/img25.e11bfbbe.JPG";